import React, { lazy, Suspense } from 'react';
import { autoChooseComponent } from '@utils/brandDiffsUtils';
const StoneLoginModal = lazy(() => import('@stone/components/login/LoginModal'));
const MonclerLoginModal = lazy(() => import('@moncler/components/login/LoginModal'));
const LoginModal = (props) => {
    return (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) }, autoChooseComponent({
        MO: React.createElement(MonclerLoginModal, Object.assign({}, props)),
        ST: React.createElement(StoneLoginModal, Object.assign({}, props)),
    })));
};
export default LoginModal;
